export default "__VITE_ASSET__CI8vk5TB__"